import { v4 as uuid } from "uuid";

/**
 * Category Database can be added here.
 * You can add category of your wish with different attributes
 * */

export const categories = [
  {
    _id: uuid(),
    categoryName: "Fiction",
    description:
      "literature in the form of prose, especially novels, thginary events and people",
  },
  {
    _id: uuid(),
    categoryName: "Non-Fiction",
    description:
      "Non-fiction is writing that gives information or describes real eventselling a story.",
  },  
  {
    _id: uuid(),
    categoryName: "Mystery",
    description:
      "Meant to often maketykytktuyk use of supernatural and paranormal elements i .",
  },  
  {
    _id: uuid(),
    categoryName: "Fantasy",
    description:
      "Meant to ofytjtyktuketen make use of supernatural and paranormal elements i .",
  }
 
];  
